import {UI} from "../../../../../stem-core/ui/UIBase";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService.js";
import {Messages} from "../../../../Messages.js";
import {BasePanelPage} from "../../../PanelPage.jsx"
import {startDashboardFlow} from "../../../flows/FlowEntrypoint.js";


export class NewsletterSubscribeSuccessPanel extends BasePanelPage {
    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.title}>
                {Messages.newsletterSubscribeSuccessTitle(iFrameMerchantService.getMerchant().getName())}
            </div>,
            <div className={styleSheet.message} style={{padding: "0 6px"}}>
                {Messages.newsletterSuccessMessage}
                <LinkButton
                    onClick={startDashboardFlow}
                    label={Messages.myAccount}
                />.
            </div>,
        ];
    }
}
